// MyTransactionsController
app.controller('TransactionController', ['$scope', 'WdHttpService', 'sessionService', 'config',
    function ($scope, WdHttpService, sessionService, config) {

        // Init 
        $scope.init = async function () {
            await $scope.fetchAdviserSiteDetails();
            if (!$scope.brokerName) {
                if (!$scope.getBrokerName()) {
                    await $scope.updateBrokerPopup();
                    return;
                }
            }
            $scope.getTransactions();
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.transactionList = [];
            $scope.isTabActive = [true, false, false];

        }

        $scope.changeTabView = function (tabNumber) {
            for (let i = 0; i < $scope.isTabActive.length; i++) {
                if (i == tabNumber)
                    $scope.isTabActive[i] = true;
                else
                    $scope.isTabActive[i] = false;
            }
        }

        $scope.getTransactions = async function () {
            var data = {
                investingMode: sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL"
            };
            $scope.showPageLoader();
            await WdHttpService._my_transactions(data)
                .then(function (response) {
                    $scope.transactionDetails = response.data.transaction;
                    angular.forEach($scope.transactionDetails, function (value) {
                        $scope.transactionList.push({
                            "action": value.action,
                            "adviserUsername": value.adviserUsername,
                            "fundCashFlow": value.fundCashFlow,
                            "fundName": value.fundName,
                            "timestamp": value.timestamp,
                            "displayName": response.data.metadata[value.fundName].displayName,
                            "fundIcon": response.data.metadata[value.fundName].fundIcon
                        });
                    });
                    $scope.groupTransaction();
                    $scope.$evalAsync();
                    $scope.hidePageLoader();

                }).catch(error => {
                    $scope.noMoreData = true;
                    $scope.showErrorPopup(error);
                    $scope.$evalAsync();
                    $scope.hidePageLoader();
                });
        }

        $scope.groupTransaction = function () {
            var subscribeList = 0;
            var exitList = 0;
            var otherList = 0;
            for (let i = 0; i < $scope.transactionList.length; i++) {
                if ($scope.transactionList[i].action === 'EQUITYSUBSCRIPTION') {
                    subscribeList = subscribeList + 1;
                } else if ($scope.transactionList[i].action === 'UNSUBSCRIPTION') {
                    exitList = exitList + 1;
                } else if ($scope.transactionList[i].action === 'SLIPPAGECASH' || 'PARTIALWITHDRAWAL' || 'Investment Adjustments' || 'ADDITIONALSUBSCRIPTION') {
                    otherList = otherList + 1;
                }
            }
            $scope.subscribeList = subscribeList;
            $scope.exitList = exitList;
            $scope.otherList = otherList;
        }

        $scope.readableText = function (action) {
            if (action == "SLIPPAGECASH") {
                return "Cash Slippage";
            } else if (action == 'PARTIALWITHDRAWAL') {
                return "Partial Withdrawal";
            } else if (action == 'Investment Adjustments') {
                return action;
            } else if (action == 'ADDITIONALSUBSCRIPTION') {
                return "Additional Subscription"
            }
            return action;
        }
    }
]);